import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { PieChart, Pie, Cell } from 'recharts';

import { getRequest } from '../../../api/ApiService';
import Auth from '../../../routes/Auth';

import Image3 from '../../../containers/assets/onboarding-trivia-final.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    font-weight: 500;
    color: #ed716d;
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
  position: relative;

  div.trivia-chart {
    position: absolute;
    top: 80px;
    left: 505px;
    width: 140px;
    height: 140px;
  }

  div.trivia-amount {
    position: absolute;
    width: 140px;
    height: 140px;
    top: 80px;
    left: 505px;

    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 48px;
    color: rgba(0, 27, 59, 0.94);

    span {
      font-size: 18px;
      line-height: 18px;
      position: relative;
      top: 7px;
    }
  }
`;

class TriviaFinal extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      value: null,
    };
  }

  componentDidMount() {
    const { stage } = this.props;

    this.props.setMode('basic');
    getRequest(`${process.env.REACT_APP_API_URL}v2/trivia/user-scores/${Auth.getUserId()}/`)
      .then(res => {
        let value = null;
        const key = stage === 'welcome' ? '0' : `${stage}`;
        if (res.body.stage_user_score && res.body.stage_user_score[key]) {
          value = (Number(res.body.stage_user_score[key]) * 100).toFixed(2);
        }

        this.setState({
          value,
        });
      })
      .catch(err => {});
  }

  render() {
    const { value } = this.state;
    const { stage } = this.props;
    const valueNumber = Number(value);

    return (
      <Wrapper>
        <Text1>Trivia: {stage === 'welcome' ? 'Warm Up' : `Round ${stage}`}</Text1>
        <Text2>Well done!</Text2>
        <Text3>
          You've completed the first trivia. Don't worry if you feel new to the field.
          We will guide you through some fundamentals of the game next.
        </Text3>
        <Image>
          <img src={Image3} alt="" />
          <div className="trivia-chart">
            <PieChart width={140} height={140} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
              <Pie
                dataKey="value"
                data={[
                  { name: 'Free', value: 100 - valueNumber },
                  ...(valueNumber > 0 ? [
                    { name: 'Total', value: valueNumber },
                  ] : []),
                ]}
                cx={70}
                cy={70}
                innerRadius={62}
                outerRadius={70}
                cornerRadius={8}
                fill="#e3e3e3"
                startAngle={90}
                endAngle={450}
              >
                <Cell fill="#e3e3e3" />
                {valueNumber > 0 && <Cell fill="#a98df6" />}
              </Pie>
            </PieChart>
          </div>

          {value && <div className="trivia-amount">{value.split('.')[0]}.<span>{value.split('.')[1]}%</span></div>}
        </Image>
      </Wrapper>
    );
  }

}

export default TriviaFinal;



// WEBPACK FOOTER //
// ./src/components/onboarding/trivia/Final.js